import BoatSharing from 'components/about/boatSharing';
import Hero from 'components/about/hero';
import SocialProof from 'components/about/socialProof';
import DefaultLayout from 'components/layouts/DefaultLayout';
import getConfig from 'next/config';
import Head from 'next/head';

const { RAILS_URL } = getConfig().publicRuntimeConfig;

const AboutPage = () => {
  const canonicalTag = `${RAILS_URL}/about`;

  return (
    <DefaultLayout white isAbout noFollow={false}>
      <Head>
        <link rel="canonical" href={canonicalTag} />
      </Head>
      <Hero />
      <SocialProof />
      <BoatSharing />
    </DefaultLayout>
  );
};

export default AboutPage;
